export default __webpack_public_path__ + "a6069540692725c247f13984a9598a92.woff2";